import { TipsMapType } from "@op/components/BubbleCommon";

export const adCreativesComparisonOverviewTipsMap: TipsMapType = {
  en: 'When a multi-day time range is selected, all indicators are calculated and presented as period-averaged daily values.',
  zh: '当选择多日时间范围时，各项指标将自动计算并展示周期内日均数值。',
};

export const adCreativesComparisonChannelShareTipsMap: TipsMapType = {
  en: `Proportion of single game's selected channel delivery in total channels, for channel strategy analysis`,
  zh: '单款游戏选定渠道投放占全渠道投放占比，用于分析渠道投放布局',
};

export const adCreativesComparisonCompetitorShareTipsMap: TipsMapType = {
  en: `Proportion of single-game channel delivery against total delivery of selected peers in the same channel, check market share of delivery among competitors`,
  zh: '单款游戏渠道投放量占选定竞品同渠道投放总量之比，可直观查看该渠道下本品在竞品中的投放份额',
};

export const engagementStatTipsMap: TipsMapType = {
  en: 'Cumulative Impressions on Active Ads. When a time period is selected, the system calculates the average daily cumulative impressions of active ads within the period.',
  zh: '在投广告累计曝光量，当选中一段时间时，计算该时间段内在投广告的日均累计曝光量。'
};


export const gameSelectTop15TipsMap: TipsMapType = {
  en: "To ensure the best comparison experience, you can select up to 15 games. We've automatically selected the first 15 for you.",
  zh: '为保证图表对比体验，最多支持选中15个游戏。已为您自动选中前15个。'
};